// Reemplazo de `notification`/`message` de antd.
// API imperativa global (usable desde componentes Y desde redux thunks),
// respaldada por un pequeño pub-sub que consume <ToastHost/>.

let idSeq = 0;
const listeners = new Set();

function emit(type, arg, arg2) {
  // Soporta: notify.error("texto")
  //          notify.error({ message, description, placement })
  //          notify.error("Título", "Descripción")  (estilo message + detalle)
  let message = "";
  let description = "";
  let placement;

  if (typeof arg === "string") {
    if (typeof arg2 === "string") {
      message = arg;
      description = arg2;
    } else {
      message = arg;
    }
  } else if (arg && typeof arg === "object") {
    message = arg.message || "";
    description = arg.description || "";
    placement = arg.placement;
  }

  const toast = {
    id: ++idSeq,
    type, // success | error | warning | info
    message,
    description,
    placement,
  };

  listeners.forEach((fn) => fn(toast));
  return toast.id;
}

export const notify = {
  success: (arg, arg2) => emit("success", arg, arg2),
  error: (arg, arg2) => emit("error", arg, arg2),
  warning: (arg, arg2) => emit("warning", arg, arg2),
  info: (arg, arg2) => emit("info", arg, arg2),
};

export function subscribeToasts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
